import "rxjs/add/operator/map";

import { AppState } from "../../states/app-state.interface";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { User } from "../../models/user.model";
import { UserActions } from "../../states/user";
import { UserProvider } from "../../providers/user/user";

@Injectable()
export class UserRepository {
  public users$ = this.store.select(res => res.users);

  constructor(
    private user: UserProvider,
    private store: Store<AppState>,
    public userActions: UserActions
  ) { }

  public index() {
    return this.user.index().map(res => {
      let users = res.data.map(user => {
        return User.create(user);
      });
      this.store.dispatch(this.userActions.addUsers({ users }));
      return users;
    });
  }

  public create(request) {
    return this.user.create(request).map((res: { data: object }) => {
      let user = User.create(res.data);
      this.store.dispatch(this.userActions.addUser({ user }));
      return user;
    });
  }

  public update(request, id) {
    return this.user.update(request, id).map((res: { data: object }) => {
      let user = User.create(res.data);
      this.store.dispatch(this.userActions.editUser({ user: user, id: id }));
      return user;
    });
  }

  public destroy(id) {
    return this.user.destroy({ id }).map(res => {
      this.store.dispatch(this.userActions.removeUser({ id: id }));
      return true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/repositories/user/user.repository.ts